import { useSolvSelector } from '~/reducers';

export const useSelectUserPosition = () => {
  return useSolvSelector((state: any) => state.position);
};

export const useSelectUserLatLong = () => {
  return useSolvSelector((state) => ({
    latitude: state?.position?.result?.latitude,
    longitude: state?.position?.result?.longitude,
  }));
};
